/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MainPage_meQueryVariables = {};
export type MainPage_meQueryResponse = {
    readonly me: {
        readonly id: string;
        readonly name: string;
        readonly email: string;
        readonly role: string;
        readonly publicUser: {
            readonly id: string;
        };
    };
};
export type MainPage_meQuery = {
    readonly response: MainPage_meQueryResponse;
    readonly variables: MainPage_meQueryVariables;
};



/*
query MainPage_meQuery {
  me {
    id
    name
    email
    role
    publicUser {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PublicUser",
        "kind": "LinkedField",
        "name": "publicUser",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MainPage_meQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MainPage_meQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd80ecc0f6b410a993a6eda083710da8",
    "id": null,
    "metadata": {},
    "name": "MainPage_meQuery",
    "operationKind": "query",
    "text": "query MainPage_meQuery {\n  me {\n    id\n    name\n    email\n    role\n    publicUser {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '2e21740354bd2bc5eaaf33387e80bc74';
export default node;
